import activation from '../../Assets/images/Activation/Steps/activation-home-ios.webp';
import settings from '../../Assets/images/Activation/Steps/settings-ios.webp';
import cellular from '../../Assets/images/Activation/Steps/cellular-ios.webp';
import cellular_plan from '../../Assets/images/Activation/Steps/cellular-plan-ios.webp';
import qrcode from '../../Assets/images/Activation/Steps/qrcode-ios.webp';
import activation_android from '../../Assets/images/Activation/Steps/activation-home-android.webp';
import settings_android from '../../Assets/images/Activation/Steps/settings-android.webp';
import connections_android from '../../Assets/images/Activation/Steps/connections-android.webp';
import sim_card_android from '../../Assets/images/Activation/Steps/sim-card-android.webp';
import mobile_plan_android from '../../Assets/images/Activation/Steps/mobile-plan-android.webp';
import scan_code_android from '../../Assets/images/Activation/Steps/scan-code-android.webp';
import qrcode_android from '../../Assets/images/Activation/Steps/qrcode-android.webp';
import confirm_plan_android from '../../Assets/images/Activation/Steps/confirm-plan-android.webp';
import download_esim_android from '../../Assets/images/Activation/Steps/downloaded-esim-android.webp';
import activation_ios_mweb from '../../Assets/images/Activation/Steps/activation-home-ios-mweb.webp';
import settings_ios_mweb from '../../Assets/images/Activation/Steps/settings-ios-mweb.webp';
import cellular_ios_mweb from '../../Assets/images/Activation/Steps/cellular-ios-mweb.webp';
import cellular_plan_ios_mweb from '../../Assets/images/Activation/Steps/cellular-plan-ios-mweb.webp';
import qrcode_ios_mweb from '../../Assets/images/Activation/Steps/qrcode-ios-mweb.webp';
import activation_android_mweb from '../../Assets/images/Activation/Steps/activation-home-android-mweb.webp';
import settings_android_mweb from '../../Assets/images/Activation/Steps/settings-android-mweb.webp';
import connections_android_mweb from '../../Assets/images/Activation/Steps/connections-android-mweb.webp';
import sim_card_android_mweb from '../../Assets/images/Activation/Steps/sim-card-android-mweb.webp';
import mobile_plan_android_mweb from '../../Assets/images/Activation/Steps/mobile-plan-android-mweb.webp';
import scan_code_android_mweb from '../../Assets/images/Activation/Steps/scan-code-android-mweb.webp';
import qrcode_android_mweb from '../../Assets/images/Activation/Steps/qrcode-android-mweb.webp';
import confirm_plan_android_mweb from '../../Assets/images/Activation/Steps/confirm-plan-android-mweb.webp';
import download_esim_android_mweb from '../../Assets/images/Activation/Steps/downloaded-esim-android-mweb.webp';

const setupSteps: any = {
    ios: [
        {
            step: 1,
            title: 'Settings',
            spanTxt: 'Tap ',
            desc: 'on the home screen.',
            boldTxt: 'Settings ',
        },
        {
            step: 2,
            title: 'Cellular',
            desc: 'Scroll down a little and choose',
            boldTxt: 'Cellular.',
        },
        {
            step: 3,
            title: 'Add Cellular Plan',
            desc: 'Choose',
            boldTxt: 'Add Cellular Plan.',
        },
        {
            step: 4,
            title: 'Scan QR Code',
            desc: 'Go ahead and scan the QR code.',
        },
    ],
    android: [
        {
            step: 1,
            title: 'Settings',
            spanTxt: 'Tap ',
            desc: 'on the home screen.',
            boldTxt: 'Settings ',
        },
        {
            step: 2,
            title: 'Connections',
            desc: 'Scroll down a little and choose',
            boldTxt: 'Connections.',
        },
        {
            step: 3,
            title: 'SIM card manager',
            desc: 'Choose',
            boldTxt: 'SIM card manager.',
        },
        {
            step: 4,
            title: 'Add mobile plan',
            desc: 'Under eSIMs, choose',
            boldTxt: 'Add mobile plan.',
        },
        {
            step: 5,
            title: 'Scan QR Code',
            desc: 'Choose',
            boldTxt: 'Scan carrier QR code.',
        },
        {
            step: 6,
            title: 'Confirm',
            desc: 'Tap',
            boldTxt: 'Confirm.',
        },
        {
            step: 7,
            title: 'Downloading eSIM',
            desc: 'Within 5 minutes your eSIM profile will',
            desc_newline: 'be downloaded.',
        },
    ],
    ios_images: [activation, settings, cellular, cellular_plan, qrcode],
    ios_images_mweb: [
        activation_ios_mweb,
        settings_ios_mweb,
        cellular_ios_mweb,
        cellular_plan_ios_mweb,
        qrcode_ios_mweb,
    ],
    android_images: [
        activation_android,
        settings_android,
        connections_android,
        sim_card_android,
        mobile_plan_android,
        scan_code_android,
        qrcode_android,
        confirm_plan_android,
        download_esim_android,
    ],
    android_images_mweb: [
        activation_android_mweb,
        settings_android_mweb,
        connections_android_mweb,
        sim_card_android_mweb,
        mobile_plan_android_mweb,
        scan_code_android_mweb,
        qrcode_android_mweb,
        confirm_plan_android_mweb,
        download_esim_android_mweb,
    ],
};
export default setupSteps;
